import { Link } from 'react-router-dom';

import { encrypt } from '../../components/utils';
import { INTEGRATIONS } from '../../components/tpi';

import Button from '../../elements/button';
import Text from '../../elements/text';

function BrowseIntegrationInfo(props) {
  const { permissions } = props.integration;
  const thirtyMinutesDisagEnabled =
    permissions &&
    permissions.length &&
    permissions[0] ===
      INTEGRATIONS.RESELLER_API_PERMS.thirtyMinutesDisaggregation;

  // Which reseller web these links point at, decided by the environment this
  // bundle was BUILT for rather than by the URL the page happens to be served
  // from. The old check asked whether the current href contained 'test-', which
  // was right in AWS test by coincidence of naming and is a trap: the
  // colocation is served at test-crm-colo.voltaware.com, so it matched there
  // too, and any future hostname without that substring would have silently
  // sent people to production.
  //
  // Behaviour is unchanged in all three environments. deploy-prod sets
  // REACT_APP_ENV=production, so production keeps the bare hostname; test and
  // local builds leave it unset and keep the 'test-' prefix.
  // A HOST per environment, not a prefix.
  //
  // The prefix version sent the colocation to AWS. `REACT_APP_ENV` is `colo`
  // there, which is not 'production', so it fell through to `test-` and built
  // `test-reseller-web.voltaware.com` - the AWS host. Someone pressing this
  // link from the colocation CRM landed in the test environment without
  // anything saying so.
  //
  // The colocation is not a prefix away from test: it is served at
  // `test-reseller-web-colo.voltaware.com`. Spelling the hosts out makes that
  // expressible, and makes the next environment one line rather than a rethink.
  const RESELLER_WEB_HOSTS = {
    production: 'reseller-web.voltaware.com',
    colo: 'test-reseller-web-colo.voltaware.com',
    test: 'test-reseller-web.voltaware.com',
  };

  // The LRD reseller web is NOT on the colocation, so `colo` is deliberately
  // absent here and falls back to test. That is a cross-environment link and it
  // is a known one: the alternative is a dead link, and the service it points
  // at has no rack equivalent to point to yet. Add the entry when it does.
  const LRD_RESELLER_WEB_HOSTS = {
    production: 'smart-meter-reseller-web.voltaware.com',
    test: 'test-smart-meter-reseller-web.voltaware.com',
  };

  const env = process.env.REACT_APP_ENV;
  const resellerWebHost = RESELLER_WEB_HOSTS[env] || RESELLER_WEB_HOSTS.test;
  const lrdResellerWebHost =
    LRD_RESELLER_WEB_HOSTS[env] || LRD_RESELLER_WEB_HOSTS.test;

  const url = `https://${resellerWebHost}/login?x=${encrypt(
    props.integration.userName
  )}&y=${encrypt(props.integration.password)}`;
  const lrdUrl = `https://${lrdResellerWebHost}/login?x=${encrypt(
    props.integration.userName
  )}&y=${encrypt(props.integration.password)}`;

  return (
    <div>
      <h6>
        {props.title}
        {props.link ? (
          <Link {...props.link}>
            <Button action="edit" />
          </Link>
        ) : null}
      </h6>
      <div>
        <Text bold={true} inline={true} text="Client ID" />
        <Text bold={false} inline={true} text={props.integration.userName} />
      </div>
      <div>
        <Text bold={true} inline={true} text="Client Secret" />
        <Text bold={false} inline={true} text={props.integration.password} />
      </div>
      <div>
        <Text bold={true} inline={true} text="30 minutes disaggregation" />
        <Text
          bold={false}
          inline={true}
          text={thirtyMinutesDisagEnabled ? 'ENABLED' : 'DISABLED'}
        />
      </div>
      <div>
        <a href={url} target="_blank" rel="noreferrer">
          <Text
            bold={true}
            inline={true}
            classes="highlight-link"
            text="Access Resellers API"
          />
        </a>
      </div>
      {props.hasStatisticalIntegration ? (
        <div>
          <a href={lrdUrl} target="_blank" rel="noreferrer">
            <Text
              bold={true}
              inline={true}
              classes="highlight-link"
              text="Access LRD Resellers API"
            />
          </a>
        </div>
      ) : null}
    </div>
  );
}

export default BrowseIntegrationInfo;
